import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FilterService, GridComponent, RowSelectEventArgs, SelectionService, SelectionSettingsModel, SortService } from '@syncfusion/ej2-angular-grids';
import { Subject, takeUntil } from 'rxjs';
import { CheckWritingService } from 'src/app/services/checkWriting.service';
import { ICheckLayoutSetUp, ICheckPrintDateRange, ICheckPrintDetails, ICheckSetUpDetails } from 'src/app/Shared/Interfaces/ICheckWriting';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { OpsCheckLayout } from 'src/app/operations/ops-point-of-sales/ops-check-layout/ops-check-layout';
import { ICommon, IResponseModel, IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { EActionTypes, ECheckLayout, ELovTypes, EPrintOrientation, EPrintPart, EToaster, EUserSecurityFunctionID } from 'src/app/Shared/enum';
import { AnnotationConstraints, ConnectorModel, Diagram, DiagramComponent, DiagramModule, NodeModel, PageSettingsModel, RulerSettingsModel, ScrollSettingsModel, SelectorConstraints, SelectorModel, PrintAndExportService } from '@syncfusion/ej2-angular-diagrams';
import { GeneralService } from 'src/app/services/general.service';
import { CurrencyInWords } from 'src/app/Shared/currencyInWords.pipe';
import { PassCodeAuthentication } from 'src/app/Shared/passcodeAuthentication/passcode-Authentication.component';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import printJS from 'print-js';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { NodeConstraints } from '@syncfusion/ej2-angular-diagrams';

@Component({
  selector: 'app-ops-check-printing',
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, UserPermissionHandlerDirective, OperationsComponent, TopBarComponent,
    WordReplacePipe, OpsCheckLayout, DiagramModule, PassCodeAuthentication, LoaderComponent, customCurrencyPipe],
  providers: [CheckWritingService, PrintAndExportService, CurrencyInWords, FilterService, SortService, SelectionService],
  standalone: true,
  templateUrl: './ops-check-printing.html',
  styleUrl: './ops-check-printing.scss'
})
export class OpsCheckPrinting implements OnInit, OnDestroy {

  @ViewChild(OpsCheckLayout, { static: false }) OpsCheckLayout: OpsCheckLayout;
  @ViewChild(PassCodeAuthentication, { static: false }) PassCodeAuthentication: PassCodeAuthentication;
  @ViewChild('diagramPrintCheck') public diagramPrintCheck: DiagramComponent;
  @ViewChild('gridCheckVendors') public gridCheckVendors: GridComponent;
  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.CheckPrinting, Action: EActionTypes.VIEW };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.CheckPrinting, Action: EActionTypes.EDIT };
  public selectedItems?: SelectorModel;
  rulerSettings: RulerSettingsModel = { showRulers: true };
  public pageSettings: PageSettingsModel = { width: 1100, height: 400 };
  public scrollSettings: ScrollSettingsModel = {
    scrollLimit: 'Diagram',
    canAutoScroll: false,
    maxZoom: 40,
    minZoom: 0.3,
  };
  isCollapsed = true;
  viewCheckPrinting: boolean = true;
  public loaderIcon: Promise<boolean>;
  selectedRecord: ICheckPrintDateRange;
  private destroy$ = new Subject<void>();
  checkPrintDateRange: ICheckPrintDateRange[] = [];
  checkPrintDetailsList: ICheckPrintDetails[] = [];
  checkLayoutSetUpList: ICheckLayoutSetUp[] = [];
  memoText = '';
  checkSetUpDetails: ICheckSetUpDetails;
  public datePipe = new DatePipe('en-US');
  printOrientationList: ICommon[] = [];
  fontNameList = [];
  fontStyleList = [];
  fontSizeList = [];
  checkFieldControlsList = [];
  dataCollection = [];
  public height: any;
  private transactionRecord: ICheckPrintDetails;
  private isSelectAll = false;
  marketCurrentDateTime: string;
  public sortOptions?: object;
  public sortOptionsRange?: object;
  public selectionOptions?: SelectionSettingsModel;
  isMemoCheckbox = false;
  sortBy: string = 'vendorId'; // default
  isAntiquesVillage = false;

  constructor(
    private checkWritingService: CheckWritingService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private generalService: GeneralService,
    private toastr: ToastrService,
    private currencyInWords: CurrencyInWords) { }

  ngOnInit(): void {
    this.loaderIcon = Promise.resolve(true);
    this.selectionOptions = { checkboxOnly: true };
    let diagramWidth: ECheckLayout = ECheckLayout.EJSDiagramWidth;
    let diagramHeight: ECheckLayout = ECheckLayout.DiagramHeight;
    let width: number = diagramWidth;
    let height: number = diagramHeight;
    this.pageSettings = { width: width, height: height };
    this.sortOptionsRange = { columns: [{ field: 'PayOutDate', direction: 'Descending' }] };
    //this.sortOptions = { columns: [{ field: 'AlphaNumericVendorId', direction: 'Ascending' }] };
    this.getCheckPrintDateRange();
    this.printOrientationList = this.checkWritingService.printOrientation;
    this.getCheckSetUpDetails();
    this.getCheckLayoutSetUpDetails();
    this.getFontName();
    this.getFontStyle();
    this.getMarketCurrentTime();
    this.loadCustomMarketSettings();
    this.selectedItems = { constraints: SelectorConstraints.All & ~SelectorConstraints.ToolTip };
    this.fontSizeList = this.sharedHTMLSettings.getFontSize();
    this.checkFieldControlsList = JSON.parse(JSON.stringify(this.checkWritingService.checkFieldControlsList));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dataBound(args) {
    if (this.gridCheckVendors && this.gridCheckVendors.filterModule)
      Object.assign((<any>this.gridCheckVendors.filterModule).filterOperators, { startsWith: 'contains' });
    setTimeout(() => {
      const content = this.gridCheckVendors?.element?.querySelector('.e-content');
      if (content) {
        content.scrollTop = 0;
      }
    }, 50);
  }

  public created() {
    this.gridCheckVendors.element.querySelectorAll('.e-filterdiv')[2].classList.add('e-hide');
    this.gridCheckVendors.element.querySelectorAll('.e-filterdiv')[3].classList.add('e-hide');
    this.gridCheckVendors.element.querySelectorAll('.e-filterdiv')[4].classList.add('e-hide');
    this.gridCheckVendors.filterSettings = { mode: 'Immediate', immediateModeDelay: 100 };
  }

  onSortChange() {
    if (this.sortBy === 'vendorId') {
      this.checkPrintDetailsList = [...this.checkPrintDetailsList].sort((a, b) => {
        const aId = (a.AlphaNumericVendorId || '').trim();
        const bId = (b.AlphaNumericVendorId || '').trim();

        const aIsNum = /^\d+$/.test(aId);
        const bIsNum = /^\d+$/.test(bId);

        // both numeric → numeric sort
        if (aIsNum && bIsNum) {
          return Number(aId) - Number(bId);
        }

        // numeric first
        if (aIsNum && !bIsNum) return -1;
        if (!aIsNum && bIsNum) return 1;

        // both alphanumeric
        return aId.localeCompare(bId);
      });
    }
    else if (this.sortBy === 'vendorName') {
      this.checkPrintDetailsList = [...this.checkPrintDetailsList].sort((a, b) =>
        (a.VendorName || '').localeCompare(b.VendorName || '')
      );
    }
  }

  getMarketCurrentTime(): void {
    this.generalService.GetMarketCurrentTime()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.marketCurrentDateTime = res.substring(5, 7) + '/' + res.substring(8, 10) + '/' + res.substring(0, 4);
        },
        error: (err) => {
        }
      });
  }

  loadCustomMarketSettings(): void {
    this.generalService.getCustomMarketSettings()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.isAntiquesVillage = res?.AntiqueVillageChanges ?? false;
        },
        error: () => {
          this.isAntiquesVillage = false;
        }
      });
  }

  printSampleCheck() {
    if (this.OpsCheckLayout)
      this.OpsCheckLayout.exportDiagram();
  }

  getCheckLayoutSetUpDetails() {
    this.checkWritingService.getCheckLayoutSetUpList().pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: ICheckLayoutSetUp[]) => {
        if (data && data.length > 0) {
          this.checkLayoutSetUpList = data;
        } else {
          this.toastr.warning($localize`:@@CheckLayoutNotAvailable:Check Layout Set Up not available`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        }
      },
      error: err => {
        this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@CheckSetUp:Check Set Up`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      }
    });
  }

  getFontName() {
    this.generalService.getListOfValuesByType(ELovTypes['Font Name']).pipe(takeUntil(this.destroy$)).subscribe({
      next: (fontName) => {
        if (fontName) {
          this.fontNameList = fontName;
        }
      },
      error: err => {
        this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@FontName:Font Name`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      }
    });
  }

  getFontStyle() {
    this.generalService.getListOfValuesByType(ELovTypes['Font Style']).pipe(takeUntil(this.destroy$)).subscribe({
      next: (fontStyle) => {
        if (fontStyle) {
          this.fontStyleList = fontStyle;
        }
      },
      error: err => {
        this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@CheckSetUp:Check Set Up`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      }
    });
  }

  getCheckSetUpDetails() {
    this.checkWritingService.getCheckSetUpDetails().pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: ICheckSetUpDetails) => {
        if (data) {
          this.checkSetUpDetails = data;
        }
      },
      error: err => {
        this.toastr.error(EToaster.MsgErrorFetch + $localize`:@@CheckSetUp:Check Set Up`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      }
    });
  }

  disableUpdateAllcheck() {
    if (this.checkPrintDetailsList.findIndex(r => r.Selected) == -1) {
      return true;
    } else if (this.memoText != "") {
      return false;
    } else {
      return true;
    }
  }

  checkMemoPrintDetailsRow(event, rowData) {
    let selectedRowData = this.checkPrintDetailsList.find(rec => rec.VendorId == rowData.VendorId);
    if (selectedRowData) {
      if (event.target.checked) {
        selectedRowData.Memo = true;
      } else {
        selectedRowData.Memo = false;
        selectedRowData.MemoText = '';
      }
    }
    this.isMemoCheckbox = true;
    this.gridCheckVendors.refreshColumns();
    this.created();
  }

  changeMemoTxtPrintDetailsRow(value: string, rowData: ICheckPrintDetails) {
    let selectedRowData = this.checkPrintDetailsList.find(
      rec =>
        rec.VendorId == rowData.VendorId &&
        rec.PayOutDate == rowData.PayOutDate
    );
    if (selectedRowData) {
      selectedRowData.MemoText = value ? value.trim() : '';
    }
  }

  getCheckPrintDateRange(): void {
    this.checkWritingService.getCheckPrintDateRange().pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: ICheckPrintDateRange[]) => {
        this.checkPrintDateRange = data;
        this.loaderIcon = Promise.resolve(false);
      },
      error: (err) => {
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  onRowSelected(args: RowSelectEventArgs): void {
    const selectedRecord = args.data;
    this.viewCheckPrinting = false;
    this.memoText = '';
    this.getSelectedRowDetails(selectedRecord);
  }

  changeSelectAll(checked) {
    this.transactionRecord = null;
    if (checked) {
      if (this.checkPrintDetailsList.findIndex(r => r.CheckPrintProcessed) != -1) {
        Swal.fire({
          title: $localize`:@@CheckAlreadyGeneratedForFew:Few Checks already has been generated!`,
          text: $localize`:@@GenerateOneMore:Do you want to generate one more check?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: $localize`:@@Yes: Yes`,
          cancelButtonText: $localize`:@@No: No`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.checkPrintDetailsList.forEach(row => {
              row.Selected = true;
            });
            this.PassCodeAuthentication.OpenModal();
            this.isSelectAll = true;
            this.subscribeToPassCodeAuth();
          } else {
            this.checkPrintDetailsList.forEach(row => {
              row.Selected = false;
              row.Memo = false;
              row.MemoText = '';
            });
          }
          this.gridCheckVendors.refreshColumns();
          this.created();
        });
      } else {
        this.checkPrintDetailsList.forEach(row => {
          row.Selected = true;
        });
      }
    } else {
      this.checkPrintDetailsList.forEach(row => {
        row.Selected = false;
        row.Memo = false;
        row.MemoText = '';
      });
      this.gridCheckVendors.refreshColumns();
      this.created();
    }
  }
  onVendorsCheckRowDeSelected(event) {
    if (event.isInteracted && this.isMemoCheckbox == false) {
      if (event.isHeaderCheckboxClicked) {
        this.changeSelectAll(false);
      } else {
        this.checkPrintDetailsRow(false, event.data);
      }
    }
    this.isMemoCheckbox = false;
  }
  onVendorsCheckRowSelected(event) {
    if (event.isInteracted && this.isMemoCheckbox == false) {
      if (event.isHeaderCheckboxClicked) {
        this.changeSelectAll(true);
      } else {
        this.checkPrintDetailsRow(true, event.data);
      }
    }
    this.isMemoCheckbox = false;
  }

  checkPrintDetailsRow(checked, rowData) {
    this.transactionRecord = null;
    let selectedRowData = this.checkPrintDetailsList.find(rec => rec.VendorId == rowData.VendorId);
    if (selectedRowData) {
      if (checked) {
        if (selectedRowData.CheckPrintProcessed) {
          setTimeout(() => {
            Swal.fire({
              title: $localize`:@@CheckAlreadyGenerated:For ${rowData.VendorName} Check already has been generated!`,
              text: $localize`:@@GenerateOneMore:Do you want to generate one more check?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: $localize`:@@Yes: Yes`,
              cancelButtonText: $localize`:@@No: No`,
            }).then((result) => {
              if (result.isConfirmed) {
                selectedRowData.Selected = true;
                this.transactionRecord = JSON.parse(JSON.stringify(selectedRowData));
                this.PassCodeAuthentication.OpenModal();
                this.isSelectAll = false;
                this.subscribeToPassCodeAuth();
              } else {
                selectedRowData.Selected = false;
                selectedRowData.Memo = false;
                selectedRowData.MemoText = '';
                this.gridCheckVendors.refreshColumns();
                this.created();
              }
            });
          }, 0);
        } else {
          selectedRowData.Selected = true;
        }
      } else {
        selectedRowData.Selected = false;
        selectedRowData.Memo = false;
        selectedRowData.MemoText = '';
      }
    }
  }

  subscribeToPassCodeAuth() {
    this.PassCodeAuthentication.passcodeAuthenciate.pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (this.isSelectAll) {
          if (response == false) {
            this.checkPrintDetailsList.forEach(row => {
              row.Selected = false;
              row.Memo = false;
              row.MemoText = '';
            });
          }
        } else {
          if (response == false && this.transactionRecord) {
            let selectedRowData = this.checkPrintDetailsList.find(rec => rec.VendorId == this.transactionRecord.VendorId);
            selectedRowData.Selected = false;
            selectedRowData.Memo = false;
            selectedRowData.MemoText = '';
          }
        }
        this.gridCheckVendors.refreshColumns();
        this.created();
      },
      error: (error) => { },
    });
  }

  updateAllChecks() {
    this.checkPrintDetailsList.forEach(rec => {
      if (rec.Selected == true) {
        rec.Memo = true;
        rec.MemoText = this.memoText;
      }
    });
    this.gridCheckVendors.refreshColumns();
    this.created();
  }

  onBeforeOpen(args: any): void {
    if (!args || !args.target || !args.target.dataset || !args.target.dataset.content) {
      args.cancel = true;
    }
  }

  getTotalCheckAmount(): number {
    return this.checkPrintDetailsList.filter(r => r.Selected).reduce((s, it) => s + it.AmountToBePaid, 0);
  }

  getSelectedRowDetails(selectedRecord) {
    this.selectedRecord = selectedRecord;
    const payoutDateStr = `${parseInt(selectedRecord.PayOutDate.substring(5, 7), 10)}/${parseInt(selectedRecord.PayOutDate.substring(8, 10), 10)}/${parseInt(selectedRecord.PayOutDate.substring(0, 4), 10)}`;
    const fromDateStr = `${parseInt(selectedRecord.FromDate.substring(5, 7), 10)}/${parseInt(selectedRecord.FromDate.substring(8, 10), 10)}/${parseInt(selectedRecord.FromDate.substring(0, 4), 10)}`;
    const toDateStr = `${parseInt(selectedRecord.ToDate.substring(5, 7), 10)}/${parseInt(selectedRecord.ToDate.substring(8, 10), 10)}/${parseInt(selectedRecord.ToDate.substring(0, 4), 10)}`;
    this.checkWritingService.getCheckPrintDetailsList(payoutDateStr, fromDateStr, toDateStr, selectedRecord.MachineName, selectedRecord.UserName).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: ICheckPrintDetails[]) => {
        this.checkPrintDetailsList = data.map(m => {
          m.Memo = false;
          m.MemoText = '';
          m.Selected = m.CheckPrintProcessed ? false : true;
          return m;
        });
      },
      error: (err) => { }
    });
  }

  cancel() {
    this.viewCheckPrinting = true;
  }

  public load(img: any) {
    this.height = img.height;
  }

  validatePrintCheck() {
    if (!this.checkSetUpDetails.CurrentCheckNumber || (isNaN(Number(this.checkSetUpDetails.CurrentCheckNumber)))) {
      Swal.fire({
        text: $localize`:@@MsgStartCheckNoNeeded:Please enter starting Check No`,
        icon: "warning",
        confirmButtonText: $localize`:@@Ok:Ok`
      });
    } else if (this.checkLayoutSetUpList.length == 0) {
      Swal.fire({
        text: $localize`:@@CheckLayoutNotAvailable:Check Layout Set Up not available`,
        icon: "warning",
        confirmButtonText: $localize`:@@Ok:Ok`
      });
    } else if (this.checkPrintDetailsList.findIndex(r => r.Selected) == -1) {
      Swal.fire({
        text: $localize`:@@NoRecordSelected:No record selected`,
        icon: "warning",
        confirmButtonText: $localize`:@@Ok:Ok`
      });
    } else {
      this.initiateCheckPrinting();
    }
  }

  printVendorCheckTop(vendor: ICheckPrintDetails) {
    const x1 = Number(this.checkSetUpDetails.X1);
    const y1 = Number(this.checkSetUpDetails.Y1);
    this.checkLayoutSetUpList.forEach(control => {
      if (control.CheckPrintPart == EPrintPart[EPrintPart.Top] && control.IsVisible == true) {

        if (control.IsLine) {
          const connector: (ConnectorModel) = this.modelControlsToConnector(JSON.parse(JSON.stringify(control)), vendor);
          if ((!isNaN(x1) && x1 > 0) || (!isNaN(y1) && y1 > 0)) {
            if (!isNaN(x1) && x1 > 0) {
              connector.sourcePoint.x = connector.sourcePoint.x + x1;
              connector.targetPoint.x = connector.targetPoint.x + x1;
            }
            if (!isNaN(y1) && y1 > 0) {
              connector.sourcePoint.y = connector.sourcePoint.y + y1;
              connector.targetPoint.y = connector.targetPoint.y + y1;
            }
          }
          (this.diagramPrintCheck as Diagram).add(connector);
        } else {
          const node: (NodeModel) = this.modelControlsToNode(JSON.parse(JSON.stringify(control)), vendor);
          if ((!isNaN(x1) && x1 > 0) || (!isNaN(y1) && y1 > 0)) {
            if (!isNaN(x1) && x1 > 0) {
              node.offsetX = node.offsetX + x1;
            }
            if (!isNaN(y1) && y1 > 0) {
              node.offsetY = node.offsetY + y1;
            }
          }
          (this.diagramPrintCheck as Diagram).add(node);
        }
      }
    });
  }

  printVendorCheckMiddle(vendor: ICheckPrintDetails) {
    const x2 = Number(this.checkSetUpDetails.X2);
    const y2 = Number(this.checkSetUpDetails.Y2);
    this.checkLayoutSetUpList.forEach(control => {
      if (control.CheckPrintPart == EPrintPart[EPrintPart.Middle] && control.IsVisible == true) {
        if (control.IsLine) {
          const connector: (ConnectorModel) = this.modelControlsToConnector(JSON.parse(JSON.stringify(control)), vendor);
          if ((!isNaN(x2) && x2 > 0) || (!isNaN(y2) && y2 > 0)) {
            if (!isNaN(x2) && x2 > 0) {
              connector.sourcePoint.x = connector.sourcePoint.x + x2;
              connector.targetPoint.x = connector.targetPoint.x + x2;
            }
            if (!isNaN(y2) && y2 > 0) {
              connector.sourcePoint.y = connector.sourcePoint.y + y2;
              connector.targetPoint.y = connector.targetPoint.y + y2;
            }
          }
          (this.diagramPrintCheck as Diagram).add(connector);
        } else {
          const node: (NodeModel) = this.modelControlsToNode(JSON.parse(JSON.stringify(control)), vendor);
          if ((!isNaN(x2) && x2 > 0) || (!isNaN(y2) && y2 > 0)) {
            if (!isNaN(x2) && x2 > 0) {
              node.offsetX = node.offsetX + x2;
            }
            if (!isNaN(y2) && y2 > 0) {
              node.offsetY = node.offsetY + y2;
            }
          }
          (this.diagramPrintCheck as Diagram).add(node);
        }
      }
    });
  }

  printVendorCheckBottom(vendor: ICheckPrintDetails) {
    const x3 = Number(this.checkSetUpDetails.X3);
    const y3 = Number(this.checkSetUpDetails.Y3);
    this.checkLayoutSetUpList.forEach(control => {
      if (control.CheckPrintPart == EPrintPart[EPrintPart.Bottom] && control.IsVisible == true) {
        if (control.IsLine) {
          const connector: (ConnectorModel) = this.modelControlsToConnector(JSON.parse(JSON.stringify(control)), vendor);
          if ((!isNaN(x3) && x3 > 0) || (!isNaN(y3) && y3 > 0)) {
            if (!isNaN(x3) && x3 > 0) {
              connector.sourcePoint.x = connector.sourcePoint.x + x3;
              connector.targetPoint.x = connector.targetPoint.x + x3;
            }
            if (!isNaN(y3) && y3 > 0) {
              connector.sourcePoint.y = connector.sourcePoint.y + y3;
              connector.targetPoint.y = connector.targetPoint.y + y3;
            }
          }
          (this.diagramPrintCheck as Diagram).add(connector);
        } else {
          const node: (NodeModel) = this.modelControlsToNode(JSON.parse(JSON.stringify(control)), vendor);
          if ((!isNaN(x3) && x3 > 0) || (!isNaN(y3) && y3 > 0)) {
            if (!isNaN(x3) && x3 > 0) {
              node.offsetX = node.offsetX + x3;
            }
            if (!isNaN(y3) && y3 > 0) {
              node.offsetY = node.offsetY + y3;
            }
          }
          (this.diagramPrintCheck as Diagram).add(node);
        }
      }
    });
  }

  pushPrintDiagramToCollection() {
    this.diagramPrintCheck.pageSettings = { width: this.pageSettings.width, height: 1500 }; // needs to be same for layout and prinitng component
    const data = this.diagramPrintCheck.exportDiagram({
      format: 'SVG',
      mode: 'Data',
      region: 'PageSettings'
    });
    this.dataCollection.push(data);
  }

  popupClosePrintPreview() {
    Swal.fire({
      text: $localize`:@@MsgClosePrintPreviewToProceed:Please print and close Print Preview browser tab to proceed.`,
      icon: "warning",
      confirmButtonText: $localize`:@@Ok:Ok`
    });
  }


  async printDiagram() {
    this.popupClosePrintPreview();
    this.loaderIcon = Promise.resolve(false);
    let htmlContentList = [];
    try {
      for (var i = 0; i < this.dataCollection.length; i++) {
        let rawSvg = this.dataCollection[i];
        const svgString = typeof rawSvg === 'string'
          ? rawSvg
          : rawSvg?.outerHTML ?? '';

        const htmlContent = `
          <div style="text-align: center;">
            ${svgString}
          </div>
        `;
        htmlContentList.push(htmlContent);
      }
      printJS({
        printable: htmlContentList,
        type: 'raw-html',
        style: `
        @media print {
          @page {
            size: A4;
            margin: 0;
          }
    
          body {
            margin: 0;
            padding: 0;
          }
    
          .svg-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 90vh;
            overflow: hidden;
          }
    
          .svg-container svg {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
          }
          @font-face {
            font-family: 'MICR';
            src: url('/assets/fonts/MICR/micr.ttf') format('truetype');
            font-weight: 600;
            font-style: normal;
          }
        }
      `,
      });
    }
    catch {

      for (var j = 0; i < this.dataCollection.length; i++) {
        const svgElement = this.dataCollection[j];
        /// Convert DOM element to string
        const svgString = (svgElement as SVGSVGElement).outerHTML;
        const bounds = this.diagramPrintCheck.getDiagramBounds();
        const viewBox = `0 0 ${bounds.width} ${bounds.height}`;

        // Inject viewBox and preserveAspectRatio
        let svgWithAttrs = svgString
          .replace(
            /<svg([^>]*)(?<!viewBox=["'][^"']*["'])/,
            `<svg viewBox="${viewBox}" preserveAspectRatio="xMidYMid meet"$1`
          )
          .replace(/width="[^"]*"/, 'width="100vw"')
          .replace(/height="[^"]*"/, 'height="auto"');

        var htmlContent = "<div id='print-section'>" +
          "<div style='text-align: center;'>" +
          svgWithAttrs
        "</div>" +
          "</div>";
        htmlContentList.push(htmlContent);
      }
      printJS({
        printable: htmlContentList,
        type: 'raw-html',
        style: `
        @media print {
          html, body {
            margin: 0;
            padding: 0;
            width: 120vw;
          }

          h2 {
            text-align: center;
          }

          svg {
            width: 120vw !important;
            height: auto !important;
            display: block;
            margin: 0 auto;
          }
          @font-face {
            font-family: 'MICR';
            src: url('/assets/fonts/MICR/micr.ttf') format('truetype');
            font-weight: 600;
            font-style: normal;
          }
        }
      `,
      });
    }
  }

  initiateCheckPrinting() {
    this.loaderIcon = Promise.resolve(true);
    (this.diagramPrintCheck as Diagram).clear();
    const emptyarray = [];
    this.dataCollection = JSON.parse(JSON.stringify(emptyarray));
    let selectedCheckPrintVendorList = this.checkPrintDetailsList.filter(r => r.Selected);
    switch (this.checkSetUpDetails.CheckOrientation) {
      case EPrintOrientation['1PerPage']:
        selectedCheckPrintVendorList.forEach(vendor => {
          if (vendor.Selected) {
            this.updateCheckNoToCheckPrintList(vendor, this.checkSetUpDetails.CurrentCheckNumber);
            this.printVendorCheckTop(vendor);
            this.pushPrintDiagramToCollection();
            (this.diagramPrintCheck as Diagram).clear();
            this.checkSetUpDetails.CurrentCheckNumber = Number(this.checkSetUpDetails.CurrentCheckNumber) + 1;
          }
        });
        break;
      case EPrintOrientation['2PerPage']:
        selectedCheckPrintVendorList.forEach((vendor, index) => {
          if (vendor.Selected) {
            this.updateCheckNoToCheckPrintList(vendor, this.checkSetUpDetails.CurrentCheckNumber);

            if (this.checkSetUpDetails.OnePlusOne) {
              this.printVendorCheckTop(vendor);
              this.printVendorCheckMiddle(vendor);
              this.pushPrintDiagramToCollection();
              (this.diagramPrintCheck as Diagram).clear();
            } else {
              if (index % 2 == 0) {
                this.printVendorCheckTop(vendor);
              } else {
                this.printVendorCheckMiddle(vendor);
              }
              if (index % 2 == 1 || (index == (selectedCheckPrintVendorList.length - 1))) {
                this.pushPrintDiagramToCollection();
                (this.diagramPrintCheck as Diagram).clear();
              }
            }
            this.checkSetUpDetails.CurrentCheckNumber = Number(this.checkSetUpDetails.CurrentCheckNumber) + 1;
          }
        });
        break;
      case EPrintOrientation['3PerPage']:
        selectedCheckPrintVendorList.forEach((vendor, index) => {
          if (vendor.Selected) {
            this.updateCheckNoToCheckPrintList(vendor, this.checkSetUpDetails.CurrentCheckNumber);

            if (this.checkSetUpDetails.OnePlusTwo) {
              this.printVendorCheckTop(vendor);
              this.printVendorCheckMiddle(vendor);
              this.printVendorCheckBottom(vendor);
              this.pushPrintDiagramToCollection();
              (this.diagramPrintCheck as Diagram).clear();
            } else {
              if (index % 3 == 0) {
                this.printVendorCheckTop(vendor);
              } else if (index % 3 == 1) {
                this.printVendorCheckMiddle(vendor);
              } else {
                this.printVendorCheckBottom(vendor);
              }
              if (index % 3 == 2 || (index == (selectedCheckPrintVendorList.length - 1))) {
                this.pushPrintDiagramToCollection();
                (this.diagramPrintCheck as Diagram).clear();
              }
            }
            this.checkSetUpDetails.CurrentCheckNumber = Number(this.checkSetUpDetails.CurrentCheckNumber) + 1;
          }
        });
        break;
    }
    this.printDiagram();
    this.updateCheckPrint();
  }

  updateCheckPrint() {
    this.loaderIcon = Promise.resolve(true);
    this.checkWritingService.UpdateCheckPrints(this.checkPrintDetailsList.filter(r => r.Selected)).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: IResponseModel) => {
        if (data.Success) {
          this.toastr.success(EToaster.MsgSuccessSave + $localize`:@@CheckPrinting:Check Printing`, EToaster.TitleSuccess, this.sharedHTMLSettings.ToasterConfig);
        } else {
          this.toastr.error(EToaster.MsgErrorSave + $localize`:@@CheckPrinting:Check Printing`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
        }
        this.loaderIcon = Promise.resolve(false);
      },
      error: err => {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error(EToaster.MsgErrorSave + $localize`:@@CheckPrinting:Check Printing`, EToaster.TitleError, this.sharedHTMLSettings.ToasterConfig);
      }
    });
  }

  mapCheckSetUpData(controlName: string, vendor: ICheckPrintDetails) {
    let content: string;
    switch (controlName) {
      case 'txtCompanyName':
        content = `${this.checkSetUpDetails.MarketName}
      ${this.checkSetUpDetails.Address}
      ${this.checkSetUpDetails.City}
      ${this.checkSetUpDetails.ZipCode}`;
        break;
      case 'txtBankName':
        content = `${this.checkSetUpDetails.BankName}
      ${this.checkSetUpDetails.BankAddress}
      ${this.checkSetUpDetails.BankCity}
      ${this.checkSetUpDetails.BankZipCode}`;
        break;
      case 'txtBankTransitCode': content = this.checkSetUpDetails.TransitCode;
        break;
      case 'txtCheckNumber':
        content = this.checkSetUpDetails.CurrentCheckNumber?.toString();
        break;
      case 'txtAmountinWords':
        content = this.currencyInWords.transform(JSON.parse(JSON.stringify(vendor.AmountToBePaid)));
        break;
      case 'lnAmountLine':
        content = this.currencyInWords.transform(JSON.parse(JSON.stringify(vendor.AmountToBePaid)));
        break;
      case 'lnMemoLine':
        content = vendor.MemoText;
        break;
      case 'txtMemo':
        content = vendor.MemoText;
        break;
      case 'lnPayto':
        content = vendor.VendorName;
        break;
      case 'txtVendorName':
        content = vendor.VendorName;
        break;
      case 'txtCheckAmount':
        content = Number(vendor.AmountToBePaid).toFixed(2);
        break;
      case 'txtCheckDate':
        content = this.isAntiquesVillage
          ? this.datePipe.transform(this.selectedRecord?.ToDate, 'MM/dd/yyyy')
          : this.marketCurrentDateTime;
        break;
      case 'txtMICR':
        let checkString = this.checkSetUpDetails.CurrentCheckNumber.toString();
        checkString = checkString.length >= 6 ? checkString : ('0'.repeat(6 - checkString.length) + checkString);
        content = "C" + checkString + "C " + "A" + this.checkSetUpDetails.RoutingNo + "A " + this.checkSetUpDetails.AccountNo + " C";
        break;
      case 'txtVendorID':
        content = vendor.AlphaNumericVendorId;
        break;
      case 'txtCheckDateText':
        content = 'Date';
        break;
    }
    return content;
  }

  updateCheckNoToCheckPrintList(vendor: ICheckPrintDetails, currentCheckNumber: number) {
    let selectedCheckRecord = this.checkPrintDetailsList.find(rec => rec.VendorId == vendor.VendorId && rec.PayOutDate == rec.PayOutDate);
    if (selectedCheckRecord) {
      selectedCheckRecord.CheckNo = currentCheckNumber;
    }
  }

  modelControlsToNode(control: ICheckLayoutSetUp, vendor: ICheckPrintDetails): NodeModel {
    if (control.ControlName === 'imgSignature') {
      const controlConfig = this.checkFieldControlsList.find(
        co => co.ControlName === control.ControlName
      );

      let nodeModel: NodeModel = JSON.parse(JSON.stringify(this.sharedHTMLSettings.nodeDynamic));

      nodeModel.id = `${control.ControlName}${control.CheckPrintPart}`;
      nodeModel.offsetX = control.XPosition;
      nodeModel.offsetY = control.YPosition;
      nodeModel.width = controlConfig?.Width ?? 180;
      nodeModel.height = controlConfig?.Height ?? 45;
      nodeModel.constraints = NodeConstraints.Default & ~NodeConstraints.Rotate;

      nodeModel.visible =
        control.IsVisible &&
        !!this.checkSetUpDetails?.CheckSignatureUrl;

      nodeModel.shape = {
        type: 'Image',
        source: this.checkSetUpDetails.CheckSignatureUrl
      };

      // Image node should not have text annotations
      nodeModel.annotations = [];
      nodeModel.style = {
        fill: 'transparent',
        strokeColor: 'transparent'
      };

      nodeModel.addInfo = {
        CheckLayoutSetupId: control.CheckLayoutSetupId,
        ControlName: control.ControlName,
        ControlCaption: control.ControlCaption,
        IsVisible: control.IsVisible,
        XPosition: control.XPosition,
        YPosition: control.YPosition,
        DefaultXPosition: control.DefaultXPosition,
        DefaultYPosition: control.DefaultYPosition,
        DefaultValue: control.DefaultValue,
        DefaultLineLength: control.DefaultLineLength,
        FontNameId: null,
        FontStyleId: null,
        FontSize: null,
        IsLine: false,
        LineLength: control.LineLength,
        LineSize: null,
        CheckPrintPart: control.CheckPrintPart
      };

      return nodeModel;
    }

    let nodeModel: NodeModel = this.sharedHTMLSettings.nodeDynamic;
    nodeModel.id = `${control.ControlName}${control.CheckPrintPart}`;
    const amountInWordsObject = this.checkFieldControlsList.find(co => co.ControlName == 'txtAmountinWords');
    const content = this.mapCheckSetUpData(control.ControlName, vendor);
    nodeModel.annotations = [{
      content: (control.ControlName == 'txtAmountinWords') ? (this.checkWritingService.getAmountInLineWithSymbol(content ?? control.DefaultValue, amountInWordsObject.DefaultLineLength, control.FontSize))
        : (content ?? control.DefaultValue),
      style: {
        fontFamily: control.ControlName == "txtMICR" ? 'MICR' : this.fontNameList.find(f => f.Id == control.FontNameId)?.Name,
        bold: (control.FontStyleId && this.fontStyleList.find(f => f.Id == control.FontStyleId).Name == ECheckLayout.Bold) ? true : false,
        italic: (control.FontStyleId && this.fontStyleList.find(f => f.Id == control.FontStyleId).Name == ECheckLayout.Italic) ? true : false,
        fontSize: control.FontSize,
        textAlign: 'Left',
        textWrapping: 'NoWrap'
      },
      horizontalAlignment: 'Stretch'
    }];
    nodeModel.offsetX = control.XPosition;
    nodeModel.offsetY = control.YPosition;
    nodeModel.width = this.checkFieldControlsList.find(co => co.ControlName == control.ControlName).Width;
    nodeModel.visible = control.IsVisible;
    nodeModel.addInfo = {
      CheckLayoutSetupId: control.CheckLayoutSetupId,
      ControlName: control.ControlName,
      ControlCaption: control.ControlCaption,
      IsVisible: control.IsVisible,
      XPosition: control.XPosition,
      YPosition: control.YPosition,
      DefaultXPosition: control.DefaultXPosition,
      DefaultYPosition: control.DefaultYPosition,
      DefaultValue: control.DefaultValue,
      DefaultLineLength: null,
      FontNameId: control.FontNameId,
      FontStyleId: control.FontStyleId,
      FontSize: control.FontSize,
      IsLine: false,
      LineLength: null,
      LineSize: null,
      CheckPrintPart: control.CheckPrintPart,
    };
    return nodeModel;
  }

  modelControlsToConnector(control: ICheckLayoutSetUp, vendor: ICheckPrintDetails): ConnectorModel {
    const connectorModel: ConnectorModel = this.sharedHTMLSettings.connectorDynamic;
    connectorModel.id = `${control.ControlName}${control.CheckPrintPart}`;
    let content = this.mapCheckSetUpData(control.ControlName, vendor);

    connectorModel.annotations = [{
      content: (control.ControlName == 'lnAmountLine') ? (this.checkWritingService.getAmountInLineWithSymbol(content, control.LineLength, control.FontSize))
        : (content ?? control.DefaultValue),
      offset: 0,
      alignment: 'Before',
      displacement: { x: 0, y: 5 },
      constraints: AnnotationConstraints.ReadOnly,
      style: {
        fontFamily: this.fontNameList.find(f => f.Id == control.FontNameId)?.Name,
        bold: (control.FontStyleId && this.fontStyleList.find(f => f.Id == control.FontStyleId).Name == ECheckLayout.Bold) ? true : false,
        italic: (control.FontStyleId && this.fontStyleList.find(f => f.Id == control.FontStyleId).Name == ECheckLayout.Italic) ? true : false,
        fontSize: control.FontSize
      }
    }];

    connectorModel.sourcePoint = { x: control.XPosition, y: control.YPosition };
    connectorModel.targetPoint = { x: control.XPosition + control.LineLength, y: (control.YPosition) };
    connectorModel.style = { strokeWidth: control.LineSize };
    connectorModel.visible = control.IsVisible;
    connectorModel.addInfo = {
      CheckLayoutSetupId: control.CheckLayoutSetupId,
      ControlName: control.ControlName,
      ControlCaption: control.ControlCaption,
      IsVisible: control.IsVisible,
      XPosition: control.XPosition,
      YPosition: control.YPosition,
      DefaultXPosition: control.DefaultXPosition,
      DefaultYPosition: control.DefaultYPosition,
      DefaultValue: control.DefaultValue,
      IsLine: true,
      LineSize: control.LineSize,
      LineLength: control.LineLength,
      DefaultLineLength: control.DefaultLineLength,
      FontNameId: control.FontNameId,
      FontStyleId: control.FontStyleId,
      FontSize: control.FontSize,
      CheckPrintPart: control.CheckPrintPart,
    };
    return connectorModel;
  }
}
